import React from 'react';
import SendInvoiceEmails from '../../billing/SendInvoiceEmails';

const UnsentTab = () => <SendInvoiceEmails />;

export default UnsentTab;
